import type { OptionalQuery as OptionalQuery_yoa6bl } from '../pages/w/[workspaceId]/customers/[customerId]/index.page';
import type { Query as Query_e8zptp } from '../pages/w/[workspaceId]/settings/index.page';

export const pagesPath = {
  '$404': {
    $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/404' as const, hash: url?.hash })
  },
  _legacyPath: (legacyPath: string[]) => ({
    $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/[...legacyPath]' as const, query: { legacyPath }, hash: url?.hash })
  }),
  'debug': {
    'auth': {
      $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/debug/auth' as const, hash: url?.hash })
    }
  },
  'r': {
    'es': {
      'customer': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/r/es/customer' as const, hash: url?.hash })
      }
    }
  },
  'w': {
    _workspaceId: (workspaceId: string | number) => ({
      'advanced_search': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/advanced-search' as const, query: { workspaceId }, hash: url?.hash })
      },
      'customers': {
        _customerId: (customerId: string | number) => ({
          $url: (url?: { query?: OptionalQuery_yoa6bl | undefined, hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/customers/[customerId]' as const, query: { workspaceId, customerId, ...url?.query }, hash: url?.hash })
        })
      },
      'home': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/home' as const, query: { workspaceId }, hash: url?.hash })
      },
      'messaging_tasks': {
        'sending': {
          $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/messaging-tasks/sending' as const, query: { workspaceId }, hash: url?.hash })
        },
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/messaging-tasks' as const, query: { workspaceId }, hash: url?.hash })
      },
      'recording_sessions': {
        _recordingSessionId: (recordingSessionId: string | number) => ({
          $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/recording-sessions/[recordingSessionId]' as const, query: { workspaceId, recordingSessionId }, hash: url?.hash })
        }),
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/recording-sessions' as const, query: { workspaceId }, hash: url?.hash })
      },
      'settings': {
        'ai_apps': {
          _aiAppId: (aiAppId: string | number) => ({
            'edit': {
              $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/settings/ai-apps/[aiAppId]/edit' as const, query: { workspaceId, aiAppId }, hash: url?.hash })
            }
          }),
          'create': {
            _appId: (appId: string | number) => ({
              $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/settings/ai-apps/create/[appId]' as const, query: { workspaceId, appId }, hash: url?.hash })
            })
          }
        },
        'customer_fields': {
          'edit': {
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/settings/customer-fields/edit' as const, query: { workspaceId }, hash: url?.hash })
          }
        },
        'customer_visit_fields': {
          'edit': {
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/settings/customer-visit-fields/edit' as const, query: { workspaceId }, hash: url?.hash })
          }
        },
        'es_connection': {
          'edit': {
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/settings/es-connection/edit' as const, query: { workspaceId }, hash: url?.hash })
          }
        },
        'karte_schema_series': {
          _id: (id: string | number) => ({
            'edit': {
              $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/settings/karte-schema-series/[id]/edit' as const, query: { workspaceId, id }, hash: url?.hash })
            }
          }),
          'create': {
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/settings/karte-schema-series/create' as const, query: { workspaceId }, hash: url?.hash })
          }
        },
        'karte_settings': {
          'edit': {
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/settings/karte-settings/edit' as const, query: { workspaceId }, hash: url?.hash })
          }
        },
        'messaging_task_rules': {
          _id: (id: string | number) => ({
            'edit': {
              $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/settings/messaging-task-rules/[id]/edit' as const, query: { workspaceId, id }, hash: url?.hash })
            }
          }),
          'create': {
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/settings/messaging-task-rules/create' as const, query: { workspaceId }, hash: url?.hash })
          }
        },
        $url: (url: { query: Query_e8zptp, hash?: string | undefined }) => ({ pathname: '/w/[workspaceId]/settings' as const, query: { workspaceId, ...url.query }, hash: url.hash })
      },
      'support': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/support' as const, query: { workspaceId }, hash: url?.hash })
      },
      'todos': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/todos' as const, query: { workspaceId }, hash: url?.hash })
      },
      'transcripts': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/transcripts' as const, query: { workspaceId }, hash: url?.hash })
      },
      $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]' as const, query: { workspaceId }, hash: url?.hash })
    })
  },
  $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/' as const, hash: url?.hash })
};

export type PagesPath = typeof pagesPath;

export const staticPath = {
  LINE_Brand_icon_png: '/LINE_Brand_icon.png',
  apple_touch_icon_png: '/apple-touch-icon.png',
  ataraxia_logo_png: '/ataraxia_logo.png',
  circles_svg: '/circles.svg',
  favicon_ico: '/favicon.ico',
  icon_192_png: '/icon-192.png',
  icon_512_png: '/icon-512.png',
  icon_svg: '/icon.svg',
  logo_png: '/logo.png',
  manifest_json: '/manifest.json'
} as const;

export type StaticPath = typeof staticPath;
